// extracted by mini-css-extract-plugin
module.exports = {"s1kdr47h":"s1kdr47h"};